module.exports = __webpack_public_path__ + "img/title.174684ea.png";